import { createApiClientForEndpoint } from "../lib/apiClient";

const api = createApiClientForEndpoint("locations");

// Trigger-time snapshot: positions seeded from user_last_known_location at
// the moment the alarm was triggered. Never overwritten by live updates.
export const fetchAlarmSnapshotPositions = async ({ queryKey }) => {
  const [, alarmId] = queryKey;
  if (!alarmId) return [];
  const response = await api.get(`/alarm/${alarmId}/snapshot`);
  return Array.isArray(response.data) ? response.data : [];
};
